import { __assign, __extends } from "tslib";
import React from 'react';
import { Image, View, StatusBar, Easing } from 'react-native';
import { PnmacTextMobile, PnmacCard, PnmacInputRowMobile, PnmacActivityRow, PnmacScreenContainer, PnmacCollapsible, PnmacSection, PnmacCardButtonRow, PnmacNoDataAvailable, PnmacActivityIndicator, colors as c } from 'pnmac-universal-components';
import moments from 'moment';
import { currencyFormatter, paystatus, maskBankInfo, getPayStatusTranslations } from '../utils';
import { connect } from "react-redux";
import * as Actions from "../redux/actions/actions.js";
import { bindActionCreators } from "redux";
var PendingPaymentStatus = function (props) {
  var _a, _b;
  return /*#__PURE__*/React.createElement(PnmacTextMobile, {
    gilroy: true,
    black: true,
    size: 11,
    style: {
      letterSpacing: .5
    }
  }, (_b = props.translations[(_a = props.pendingPayment) === null || _a === void 0 ? void 0 : _a.status]) === null || _b === void 0 ? void 0 : _b.toUpperCase());
};
var PendingPayment = /** @class */function (_super) {
  __extends(PendingPayment, _super);
  function PendingPayment(props) {
    var _this = _super.call(this, props) || this;
    _this.state = {
      expanded: props.index === 0
    };
    _this.toggle = _this.toggle.bind(_this);
    return _this;
  }
  PendingPayment.prototype.toggle = function () {
    this.setState({
      expanded: !this.state.expanded
    });
  };
  PendingPayment.prototype.render = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y;
    var _z = this,
      props = _z.props,
      state = _z.state;
    /*From DraftSourceType enum, Web = 0, Mobile = 6*/
    var customers = parseInt((_a = props.pendingPayment) === null || _a === void 0 ? void 0 : _a.draftSource) == 0 || parseInt((_b = props.pendingPayment) === null || _b === void 0 ? void 0 : _b.draftSource) == 6;
    var achdraft = parseInt((_c = props.pendingPayment) === null || _c === void 0 ? void 0 : _c.draftSource) == 4;
    return /*#__PURE__*/React.createElement(PnmacCard, {
      style: {
        marginBottom: 20
      },
      loading: (((_d = props.pendingPayment) === null || _d === void 0 ? void 0 : _d.deletePaymentStatus) || {}).loading
    }, /*#__PURE__*/React.createElement(PnmacActivityRow, {
      topLeftBorderRadius: 0,
      topRightBorderRadius: 0,
      date: (_e = props.pendingPayment) === null || _e === void 0 ? void 0 : _e.effectiveDate,
      mainInfo: currencyFormatter('en-US', 'currency', 'USD', (_f = props.pendingPayment) === null || _f === void 0 ? void 0 : _f.totalDraftAmount),
      secondaryInfo: (_h = (_g = props.translations) === null || _g === void 0 ? void 0 : _g.fromAccount) === null || _h === void 0 ? void 0 : _h.replace("{{account}}", maskBankInfo((_j = props.pendingPayment) === null || _j === void 0 ? void 0 : _j.bankAccountNumber)),
      rightInfo: /*#__PURE__*/React.createElement(PendingPaymentStatus, __assign({}, props)),
      onPress: this.toggle
    }), /*#__PURE__*/React.createElement(PnmacSection, null, /*#__PURE__*/React.createElement(PnmacCollapsible, {
      collapsed: !this.state.expanded,
      easing: Easing.bezier(0.25, 1, .3, 1),
      duration: 500
    }, /*#__PURE__*/React.createElement(PnmacInputRowMobile, {
      label: (_k = props.translations) === null || _k === void 0 ? void 0 : _k.PendingPaymentHeaderAmount,
      value: (_l = props.pendingPayment) === null || _l === void 0 ? void 0 : _l.totalDraftAmount,
      dollar: true
    }), /*#__PURE__*/React.createElement(PnmacInputRowMobile, {
      label: (_m = props.translations) === null || _m === void 0 ? void 0 : _m.paymentBank,
      value: maskBankInfo((_o = props.pendingPayment) === null || _o === void 0 ? void 0 : _o.bankAccountNumber)
    }), /*#__PURE__*/React.createElement(PnmacInputRowMobile, {
      label: (_p = props.translations) === null || _p === void 0 ? void 0 : _p.effectiveDate,
      value: moments((_q = props.pendingPayment) === null || _q === void 0 ? void 0 : _q.effectiveDate).format("MM/DD/YYYY"),
      date: true
    }), /*#__PURE__*/React.createElement(PnmacInputRowMobile, {
      label: (_r = props.translations) === null || _r === void 0 ? void 0 : _r.confirmationNumber,
      value: (_s = props.pendingPayment) === null || _s === void 0 ? void 0 : _s.displayedConfirmationId
    }), /*#__PURE__*/React.createElement(PnmacInputRowMobile, {
      last: true,
      label: (_t = props.translations) === null || _t === void 0 ? void 0 : _t.status,
      value: getPayStatusTranslations(props.translations, (_u = props.pendingPayment) === null || _u === void 0 ? void 0 : _u.status)
    }))), /*#__PURE__*/React.createElement(PnmacCardButtonRow, {
      style: {
        borderTopWidth: 0
      }
    }, parseInt(props.pendingPayment.status) == 0 && !achdraft && !props.layout.mobile ? /*#__PURE__*/React.createElement(PnmacActivityIndicator, {
      size: 15
    }) : /*#__PURE__*/React.createElement(PnmacCardButtonRow.Button, {
      icon: state.expanded ? "chevronUp" : "chevronDown",
      text: props.translations.details,
      onPress: this.toggle
    }), ((_v = props.pendingPayment) === null || _v === void 0 ? void 0 : _v.canEdit) === true && props.editPress && customers && /*#__PURE__*/React.createElement(PnmacCardButtonRow.Button, {
      icon: "pencil",
      text: achdraft ? "View Details" : (_w = props.translations) === null || _w === void 0 ? void 0 : _w.edit,
      onPress: function () {
        return props.editPress(props.pendingPayment);
      }
    }), ((_x = props.pendingPayment) === null || _x === void 0 ? void 0 : _x.canCancel) === true && props.cancelPress && !achdraft && /*#__PURE__*/React.createElement(PnmacCardButtonRow.Button, {
      icon: "cross",
      text: (_y = props.translations) === null || _y === void 0 ? void 0 : _y.cancel,
      color: c.red,
      onPress: function () {
        return props.cancelPress(props.pendingPayment);
      }
    })));
  };
  return PendingPayment;
}(React.PureComponent);
var PendingPaymentsList = function (props) {
  var _a;
  return /*#__PURE__*/React.createElement(View, null, (_a = props.pendingPayments) === null || _a === void 0 ? void 0 : _a.map(function (pendingPayment, i) {
    return /*#__PURE__*/React.createElement(PendingPayment, __assign({
      key: i,
      index: i
    }, props, {
      pendingPayment: pendingPayment
    }));
  }));
};
var NoPendingPayments = function (props) {
  var _a, _b, _c;
  return /*#__PURE__*/React.createElement(PnmacNoDataAvailable, {
    topText: (_a = props.translations) === null || _a === void 0 ? void 0 : _a.noPendingPayments,
    bottomText: (_b = props.translations) === null || _b === void 0 ? void 0 : _b.ifCheckingPendingPayments,
    buttonText: (_c = props.translations) === null || _c === void 0 ? void 0 : _c.seeAllLoanActivity,
    onButtonPress: props.onLoanActivityPress
  });
};
var PendingPayments = function (props) {
  var _a;
  return /*#__PURE__*/React.createElement(PnmacScreenContainer, __assign({
    style: {
      backgroundColor: "none"
    }
  }, props), /*#__PURE__*/React.createElement(StatusBar, {
    barStyle: "light-content",
    animated: true
  }), /*#__PURE__*/React.createElement(PnmacScreenContainer.ScrollView, __assign({}, props, {
    refreshColor: c.gray,
    contentContainerStyle: s.scrollContent
  }), props.pendingPayments && ((_a = props.pendingPayments) === null || _a === void 0 ? void 0 : _a.length) > 0 ? /*#__PURE__*/React.createElement(PendingPaymentsList, __assign({}, props)) : /*#__PURE__*/React.createElement(NoPendingPayments, __assign({}, props))));
};
var mapStateToProps = function (state) {
  return {
    layout: state,
    translations: state.translations
  };
};
var mapDispatchToProps = function (dispatch) {
  return __assign({
    dispatch: dispatch
  }, bindActionCreators(Actions, dispatch));
};
export default connect(mapStateToProps, mapDispatchToProps)(PendingPayments);
var s = {
  scrollContent: {
    paddingTop: 0
  },
  footnote: {
    margin: 20,
    lineHeight: 19
  }
};